import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import {DFPSlotsProvider} from 'react-dfp';
import {createBrowserHistory} from 'history';
import {createPreserveQueryHistory, ScrollToTop} from './utils/routerUtils';
import MatchcenterApp from './MatchcenterApp';
import store from './store';
// import reportWebVitals from './reportWebVitals';

// TODO: remove all eslint exceptions from all files
// TODO: maybe consolidate all SVGs to single SVG sprite
// TODO: stylelint only @import scss files without output (to avoid duplicate css exporting)

const history = createPreserveQueryHistory(createBrowserHistory, ['sport24app'])({
  basename: process.env.PUBLIC_URL,
});

/**
 * The application root.
 */
const Index = () => (
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop />
      <DFPSlotsProvider dfpNetworkId="4834629" lazyLoad collapseEmptyDivs>
        <MatchcenterApp />
      </DFPSlotsProvider>
    </Router>
  </Provider>
);

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
